import { AdminBalanceAction } from '@app/store/slices/admin/adminTypes';
import { PriceType } from '@app/shared/types/common';

export const TRANSACTION_PLACEHOLDERS_MAP: Record<AdminBalanceAction, string> = {
  [AdminBalanceAction.TOP_UP]: 'credit',
  [AdminBalanceAction.WRITE_OFF]: 'debit',
};

export const TRANSACTION_OPTIONS: { value: AdminBalanceAction; translationKey: string }[] = [
  { value: AdminBalanceAction.TOP_UP, translationKey: 'credit' },
  { value: AdminBalanceAction.WRITE_OFF, translationKey: 'debit' },
];

export const BALANCE_PLACEHOLDERS_MAP: Record<PriceType, string> = {
  [PriceType.COOKIE]: '🍪',
  [PriceType.TON]: '💎',
};

export const BALANCE_OPTIONS: { value: PriceType; label: string }[] = [
  { value: PriceType.COOKIE, label: '🍪' },
  { value: PriceType.TON, label: '💎' },
];
